import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useLocation } from 'react-router-dom';
import { isPublicAuthPath } from '../../../utils/appPath';
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState<boolean>(false);
  const location = useLocation();

  const toggleSidebar = () => setShowSidebar((prev) => !prev);
  const isLiveRoom = location.pathname === "/trainer/live";
  const hideChrome = isPublicAuthPath(location.pathname) || isLiveRoom;
  const hideHeader =
    hideChrome || location.pathname.includes("/live-attendance/");

  return (
    <div style={{ backgroundColor: "#f0f0f0", minHeight: "100vh" }}>
      {!hideChrome && <Sidebar show={showSidebar} toggleSidebar={toggleSidebar} />}
      <div
        style={{
          marginLeft: hideChrome ? 0 : showSidebar ? "190px" : "70px", 
          backgroundColor: "#f0f0f0",
          // transition: "margin-left 0.3s ease", 
        }}
      >
        {!hideHeader && <Header/>}
        {children}
      </div>
    </div>
  );
};

export default Layout;
